module.exports = __webpack_public_path__ + "9c2269c4a8bde7bf22d8e071b301d997.png";